import React from 'react'

import { ROUTE_NAME, API_URL } from '../constants'

import ItemDelete from '../../components/Delete'

const IncidentTypeDelete = () => (
  <ItemDelete
    routeName={ROUTE_NAME}
    apiUrl={API_URL}
    label={(item) => `Incident Type (#${item.id}): ${item.name} - ${item.code}`}
  />
)

export default IncidentTypeDelete
